import { render, staticRenderFns } from "./ReportDetailsWidget.vue?vue&type=template&id=154cf05c&scoped=true&"
import script from "./ReportDetailsWidget.vue?vue&type=script&lang=js&"
export * from "./ReportDetailsWidget.vue?vue&type=script&lang=js&"
import style0 from "./ReportDetailsWidget.vue?vue&type=style&index=0&id=154cf05c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154cf05c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Betterway.vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('154cf05c')) {
      api.createRecord('154cf05c', component.options)
    } else {
      api.reload('154cf05c', component.options)
    }
    module.hot.accept("./ReportDetailsWidget.vue?vue&type=template&id=154cf05c&scoped=true&", function () {
      api.rerender('154cf05c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Widgets/ReportDetailsWidget.vue"
export default component.exports